import { Stack } from "@mui/material";
import React from "react";

export interface NavigationMenuItemsContainerMobileProps {
  children: React.ReactNode;
}

export function NavigationMenuItemsContainerMobile(props: NavigationMenuItemsContainerMobileProps) {
  const { children } = props;

  return (
    <Stack flexBasis="100%" flexGrow={1} flexShrink={1} overflow="hidden auto">
      {children}
    </Stack>
  );
}
